import React from 'react';
import TechnologiesSwitcher from '../../../../components/technologies.component';

export const HomeContentPrinta = props => (
  <div className='check-list-item'>
    <div className='check-list-item-progress'>
      <div className='check-list-item-index'>
      </div>
      <div className='check-list-item-sep'>
      </div>
    </div>
    <div className='check-list-item-body'>
      <p className='title'>
        <b>LLC Printa</b> <span><span className='no-mobile'>/ </span>APR 2008 - APR 2009</span>
      </p>
      <TechnologiesSwitcher>
        <p>
          <b>Computer operator at printing office (part time)</b>. This helped me get knowledge at image processing before printing in Adobe Photoshop. I prepared books and booklets for printing in Adobe InDesign. Also Improved unix base systems administration.
        </p>
        <div>
          <div className='project-list'>
            <div className='project-list-item'>
              <div className='project-list-title'>General technologies</div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Adobe Photoshop</div>
                <div>Adobe InDesign</div>
                <div>Basic Unix/Linux administration</div>
                <div>Basic Windows Server administration</div>
              </div>
            </div>
          </div>
        </div>
      </TechnologiesSwitcher>

    </div>
  </div>
);
